module.exports = __webpack_public_path__ + "img/logo_ubbi.c28156bd.png";